var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-null",style:({ height: _vm.height ? _vm.height + 'px' : 'auto' })},[_vm._v(_vm._s(_vm.tip))])}
var staticRenderFns = []

export { render, staticRenderFns }